/**
 * Suivi d'usage (Umami self-hosted, analytics.void-land.com).
 * Le script de base est dans index.html ; ce helper ne plante JAMAIS si le
 * script est absent (bloqueur de pub, chargement différé) grâce au `?.`.
 * Règles : kebab-case, une action = un nom, variantes en propriétés,
 * jamais de donnée personnelle.
 */
declare global {
  interface Window {
    umami?: { track: (name: string, data?: Record<string, string | number>) => void };
  }
}

export const track = (name: string, data?: Record<string, string | number>): void => {
  try {
    window.umami?.track(name, data);
  } catch {
    /* l'analytics ne doit jamais casser l'app */
  }
};
